import Vue from 'vue';
import Vuex, { Store } from 'vuex';
Vue.use(Vuex);
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootState {}

export default new Store<RootState>({
  modules: {
    documentEdit: {
      namespaced: true,
      modules: {
        assembler: {
          namespaced: true,
          modules: {
            fields: {
              namespaced: true,
              state: {
                fields: [],
              },
            },
          },
        },
      },
    },
  },
});
